export enum MatchFlag {
  FuPaTV = 'fupatv',
  Gallery = 'gallery',
  Ticker = 'ticker',
  Verdict = 'verdict',
  Overtime = 'overtime',
  Penalty = 'penalty',
  Cancelled = 'cancelled',
  Aborted = 'aborted',
}
